import firebase from 'firebase'

// Initialize Firebase
var config = {
    apiKey: "AIzaSyDiAuZFrw5VOFkPutBXuhD87CGYU6zRGVE",
    authDomain: "cupper-d6095.firebaseapp.com",
    databaseURL: "https://cupper-d6095.firebaseio.com",
    projectId: "cupper-d6095",
    storageBucket: "cupper-d6095.appspot.com",
    messagingSenderId: "876434554303"
  };

var fire = firebase.initializeApp(config);

export const ref = fire.database().ref()


// WEBPACK FOOTER //
// ./src/firebase.js